import { Directive, NgModule } from '@angular/core';

@Directive({
  selector: '[systemSelect]',
  host: {
    class:
      'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-system-400 focus:border-system-400 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-system-500 dark:focus:border-system-500',
  },
})
export class SelectDirective {
  constructor() {}
}

@NgModule({
  declarations: [SelectDirective],
  exports: [SelectDirective],
})
export class SystemSelectModule {}
